import React, {useState} from "react";
import "./alertBox.css";

const AlertBox = ({title, description, variant = "default", closable = true}) => {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    return (
        <div className={`alert-box alert-${variant} position-relative`}>
            {closable && (
                <button
                    type="button"
                    className="btn-close alert-box-close"
                    aria-label="Close"
                    onClick={() => setVisible(false)}
                ></button>
            )}
            <ul className="list-unstyled m-0">
                <li className="d-flex align-items-start mb-2 gap-2">
                    <i className="alert-box-icon bi bi-exclamation-triangle align-self-start"></i>
                    <div className="d-flex flex-column justify-content-start text-start gap-2">
                        <span className="alert-box-title">{title}</span>
                        <span className="alert-box-description">{description}</span>
                    </div>
                </li>
            </ul>
        </div>
    );
};

export default AlertBox;
